import { tns } from '/node_modules/tiny-slider/src/tiny-slider';

if ($('.epargne-slider .slides').length) {
    tns({
        container: '.epargne-slider .slides',
        items: 1,
        slideBy: 'page',
        autoplay: false,
        nav: false,
        loop: false,
        controlsContainer: '.controls',
        responsive: {
            620: {
                items: 2,
            },
            1024: {
                items: 3,
                edgePadding: 32,
            },
            1440: {
                items: 3,
            },
            1920: {
                items: 3,
            }
        }
    });
}